import React, { useState, useEffect, ChangeEvent } from 'react';
import {
  Container,
  Row,
  Button,
  Input,
  FormGroup,
  InputGroup,
  InputGroupAddon,
  InputGroupText,
  Col,
} from 'reactstrap';
import Header from 'components/Headers/Header.js';

import { FaPlusCircle } from 'react-icons/fa';

import api from 'services/api';

import { useQuery } from 'react-query';
import ProdutoCategoria from 'models/ProdutoCategoria';
import toast from 'react-hot-toast';
import { Checkbox, FormControlLabel, Tooltip } from '@material-ui/core';
import ProdutoModel from '../../../models/Produto';
import ListaProdutos from './components/ListaProdutos';
import ModalProduto from './components/ModalProduto';

const Produtos: React.FC = () => {
  const [formModalState, setFormModalState] = useState(false);
  const [produto, setProduto] = useState({} as any);
  const [produtosAssociados, setProdutosAssociados] = useState({} as any);
  const [mostrarDesativados, setMostrarDesativados] = useState(false);

  const [produtos, setProdutos] = useState([] as ProdutoModel[]);
  const [produtoCategorias, setProdutoCategorias] = useState<
    ProdutoCategoria[]
  >([]);

  const { data: queryProdutoCategoria } = useQuery(
    `produto-categoria`,
    async () => {
      async function getData(): Promise<ProdutoCategoria[]> {
        const response = await api.get('/produto-categoria');
        return response.data;
      }

      const dataProdutoCategoria = await getData();
      return dataProdutoCategoria;
    },
  );

  async function carregaProdutos() {
    const response = await api.get('/produto', { params: { getImagem: true } });
    console.log(response.data);
    setProdutos(response.data);
  }

  useEffect(() => {
    sessionStorage.setItem('TelaConfig', '');
  }, []);

  useEffect(() => {
    if (queryProdutoCategoria) {
      setProdutoCategorias(queryProdutoCategoria);
    }
  }, [queryProdutoCategoria]);

  function handleCriarProduto() {
    setProduto({});
    setProdutosAssociados({});
    setFormModalState(prev => !prev);
  }

  function handleDesativados(event: ChangeEvent<HTMLInputElement>) {
    const { checked } = event.target;
    setMostrarDesativados(checked);
  }

  return (
    <>
      <Header showCards={false} />
      <Container className="mt--7" fluid>
        <Row>
          <div className="col">
            <Tooltip title="Criar produto">
              <Button
                size="md"
                className="btn-icon mb-4"
                color="primary"
                type="button"
                onClick={handleCriarProduto}
              >
                <FaPlusCircle />
              </Button>
            </Tooltip>
          </div>
          <div className="col">
            <FormControlLabel
              className="float-right text-white"
              control={
                <Checkbox
                  checked={mostrarDesativados}
                  onChange={event => handleDesativados(event)}
                  color="default"
                />
              }
              label="Mostrar desativados"
            />
          </div>
        </Row>

        <Row>
          <ModalProduto
            produtos={produtos}
            carregaProdutos={carregaProdutos}
            produtoCategorias={produtoCategorias}
            produtoEditing={produto}
            setFormModalState={setFormModalState}
            formModalState={formModalState}
            setProdutoEditing={setProduto}
            produtosAssociados={produtosAssociados}
            setProdutosAssociados={setProdutosAssociados}
            produtosSelecao={produtos.filter(item => item.disabledAt === null)}
            isCreate
          />
        </Row>

        <ListaProdutos
          produtos={produtos}
          produtoCategorias={produtoCategorias}
          carregaProdutos={carregaProdutos}
          mostrarDesativados={mostrarDesativados}
        />
      </Container>
    </>
  );
};

export default Produtos;
